module.exports = __webpack_public_path__ + "static/media/india_expo_mart.2686a2af.jpg";